import { render, staticRenderFns } from "./BgImage.vue?vue&type=template&id=f5a94ad8&"
import script from "./BgImage.vue?vue&type=script&lang=js&"
export * from "./BgImage.vue?vue&type=script&lang=js&"
import style0 from "./BgImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports